import _ from 'lodash'
import React from 'react'
import PropTypes from 'prop-types'
import {
  Loader, Dimmer, Message
} from 'semantic-ui-react'


const Loading = (props) => {
  const { isLoading, errorObject } = props
  const whenIsLoading = props.whenIsLoading || (
    () => <Dimmer active page><Loader/></Dimmer>)
  const whenHasError = props.whenHasError || (
    () => (
      <Message
        negative content={errorObject.name + ': ' + errorObject.message} />))
  return isLoading ? whenIsLoading() : _.isObject(errorObject) ? whenHasError() : null
}

Loading.displayName = 'Loading'
Loading.propTypes = {
  whenIsLoading: PropTypes.func,
  whenHasError: PropTypes.func,
  isLoading: PropTypes.bool,
  hasError: PropTypes.bool
}
Loading.defaultProps = {
  isLoading: false,
  hasError: false,
}

export default Loading



// WEBPACK FOOTER //
// ./src/components/Loading.js